import React, { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions/allActions";
import { FormInput } from "../../../components/form/FormInput";
import { EventParamTypes, postLink } from "../../../types/types";
import { useFormatMessage } from "../../../utils/functions";
import ConsoleHelper from "../../../utils/logger";
import * as eState from "../../eventReducer";
import { BreadCrumb } from "../../../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";
import { useParams } from "react-router-dom";

export const Linkpage: React.FC = () => {
  const { linkId, linkPrefix, linkSuggestion } = useSelector(
    eState.getLinkPageData
  );
  const { id, subEventId } = useParams<EventParamTypes>();
  const dispatch = useDispatch();

  const handleNestedItemChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
    id: string
  ) => {
    const itemValues = id.split(":");
    dispatch(
      allActions.eventActions.changePageStyling(
        itemValues[1],
        event.target.value,
        itemValues[0]
      )
    );
  };

  const publishForm = (publish: boolean) => {
    const postLinkObject: postLink = {
      subEventId,
      publishSubEvent: publish,
      linkId,
      linkUrl: `${linkPrefix}/${linkSuggestion}`,
    };
    ConsoleHelper("going to post this linkobject", postLinkObject);
    dispatch(allActions.eventActions.startPostLinkForm(postLinkObject));
  };

  const getLinkSuggestion = useCallback(() => {
    if (!linkId) {
      dispatch(allActions.eventActions.startGetLinkSuggestion());
    }
  }, [linkId, dispatch]);

  useEffect(() => {
    getLinkSuggestion();
  }, [getLinkSuggestion]);

  return (
    <div className="container flex-col w-screen h-screen">
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb label={`event ${id}`} link={`/events/${id}`} />
        <BreadCrumb label={`subevents`} link={`/events/${id}/subevents/`} />
        <BreadCrumb
          label={`subevent ${subEventId}`}
          link={`/events/${id}/subevents/${subEventId}`}
        />
        <BreadCrumb
          label={`link`}
          link={`/events/${id}/subevents/${subEventId}/link`}
          lastChild={true}
        />
      </BreadRoute>
      <div className="container h-full max-h-11/12 w-full flex justify-center overflow-auto border my-auto border-gray-400 scroller">
        <div className="flex-col self-center w-1/2 h-5/6 mx-auto border shadow-md text-center">
          <div className="h-1/2">
            <img
              className="h-full mx-auto"
              src={`${process.env.PUBLIC_URL}/img/64621.jpg`}
              alt={`link_image`}
            />
          </div>
          <div className="p-2">
            <span className="uppercase font-semibold text-brand-dark_blue">
              link id: {linkId}
            </span>
          </div>
          <div className="p-2">
            <span className="uppercase font-semibold text-brand-dark_blue">
              link Prefix: {linkPrefix}
            </span>
          </div>
          <div>
            <FormInput
              divStyle="w-1/4 mx-auto"
              value={linkSuggestion || ""}
              labelStyle="p-2 uppercase font-semibold font-sm text-brand-dark_blue"
              inputStyle="focus:outline-none focus:bg-blue-100 focus:shadow-inner border border-gray-300 rounded-lg py-1 px-2 m-2 appearance-none leading-normal"
              question={useFormatMessage("Form.SubEvent.LinkSuggestion")}
              handleInputChange={handleNestedItemChange}
              id="linkSuggestion:link"
              type="text"
            />
          </div>
          <div className="flex justify-around w-1/4 mx-auto">
            <div>
              <button
                className="bg-blue-400 hover:bg-brand-blue font-thin text-brand-white py-2 px-4 rounded m-5"
                onClick={() => publishForm(false)}
              >
                <FormattedMessage
                  id="LinkPage.save.button"
                  defaultMessage="Save"
                />
              </button>
            </div>
            <div>
              <button
                className="bg-blue-400 hover:bg-brand-blue font-thin text-brand-white py-2 px-4 rounded m-5"
                onClick={() => publishForm(true)}
              >
                <FormattedMessage
                  id="LinkPage.publish.button"
                  defaultMessage="Publish"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Linkpage;
